module.exports = __webpack_public_path__ + "static/media/16_shape_r.3452e231.webp";